/**
 * A lista do que falta ao caso digital (E193.F1 — GUS-259, ADR-0139): tudo de uma vez. Aparece no
 * Andamento do caso no portal, no recibo do envio e na pré-análise da equipe; sem pendência, não
 * aparece. E216.F2 (GUS-317 item 6): o documento declarado pelo nome, em negrito, sem o hash.
 */
import { ptBR } from '@/i18n/pt-BR';
import { partesDoPendente, type ArquivoPendenteData } from '@/lib/arquivos_pendentes';

const t = ptBR.arquivosPendentes;

export interface ArquivosPendentesProps {
  pendentes: readonly ArquivoPendenteData[] | undefined;
  /** O texto acima da lista: o do cliente, o da equipe ou o do envio. */
  texto: string;
  /** Sem título, para a linha do recibo do envio. */
  compacto?: boolean;
  testId?: string;
  className?: string;
}

export function ArquivosPendentes({
  pendentes,
  texto,
  compacto = false,
  testId = 'arquivos-pendentes',
  className = '',
}: ArquivosPendentesProps): JSX.Element | null {
  if (!pendentes || pendentes.length === 0) return null;
  return (
    <section
      role="status"
      aria-label={t.titulo}
      data-testid={testId}
      className={`border border-situacao-attention-border bg-situacao-attention-bg px-4 py-3 text-[14px] leading-[1.5] text-situacao-attention-fg ${className}`}
    >
      {compacto ? null : <h3 className="mb-1 text-[14px] font-semibold">{t.titulo}</h3>}
      <p>{texto}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        {pendentes.map((p) => (
          <li key={`${p.codigo}:${p.sha256 ?? ''}:${p.rotulo ?? ''}`} className="break-words">
            <ItemPendente pendente={p} />
          </li>
        ))}
      </ul>
    </section>
  );
}

function ItemPendente({ pendente }: { pendente: ArquivoPendenteData }): JSX.Element {
  const { texto, nome } = partesDoPendente(pendente);
  if (nome === undefined) return <>{texto}</>;
  return (
    <>
      {texto}
      <strong className="font-semibold">{nome}</strong>
    </>
  );
}
